<template>
  <div class="px-3 pt-2 h-full overflow-auto pb-5">
    <template v-if="!isAgent">
      <VariableSelect
        v-model="chart.variable"
        label="Assign to Variable"
        class="flex-grow"
        :filter-data-type="['Chart']"
        :placeholder="$t('evaluate.select_variable')"
        @update:modelValue="emitPayload"
      >
      </VariableSelect>
      <VariableSelect v-model="chart.data" label="Data" class="mt-3 flex-grow" selectBgColor="bg-white" :filter-data-type="['DataTable']" :showCreate="false" @update:modelValue="emitPayload" />
    </template>
    <div v-else class="text-11 text-gray-400 mb-2">The agent provides the data to chart and receives the result. You only restrict which chart types it may generate.</div>
    <FormSelect
      label="Limit Chart Generation To (Leave empty for auto)"
      multiple
      v-model="chart.charts"
      :options="charts"
      :reduce="(option) => option.value"
      class="w-full mt-3"
      @update:modelValue="emitPayload"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EvaluateItemsConfig from '@/components/flow/evaluate/EvaluateItemsConfig';
import debounce from '../../../helpers/debounce';

export default {
  name: 'ChartConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
    isAgent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chart: structuredClone(EvaluateItemsConfig['data-chart'].payload),
      charts: [
        { label: 'Area', value: 'Area' },
        { label: 'Area Stacked', value: 'AreaStacked' },
        { label: 'Bar', value: 'Bar' },
        { label: 'Bar Grouped', value: 'BarGrouped' },
        { label: 'Bar Grouped Stacked', value: 'BarGroupedStacked' },
        { label: 'Bar Histogram', value: 'BarHistogram' },
        { label: 'Bar Horizontal', value: 'BarHorizontal' },
        { label: 'Bar Quarterly', value: 'BarQuarterly' },
        { label: 'Bar Stacked', value: 'BarStacked' },
        { label: 'Bar Yearly', value: 'BarYearly' },
        { label: 'Donut', value: 'Donut' },
        { label: 'Gauge', value: 'Gauge' },
        { label: 'Heatmap', value: 'Heatmap' },
        { label: 'Line', value: 'Line' },
        { label: 'Line Bar', value: 'LineBar' },
        { label: 'Line Multiple', value: 'LineMultiple' },
        { label: 'Line Stacked', value: 'LineStacked' },
        { label: 'Pie', value: 'Pie' },
        { label: 'Radar', value: 'Radar' },
        { label: 'Radial Bar', value: 'RadialBar' },
        { label: 'SparkLine', value: 'SparkLine' },
        { label: 'Timeline', value: 'Timeline' },
        { label: 'Treemap', value: 'Treemap' },
      ],
    };
  },
  computed: {
    ...mapState(['projectData']),
    projectId() {
      return this.$route.params.projectId;
    },
    variables() {
      return this.projectData?.[this.projectId]?.variables || {};
    },
    payload() {
      return {
        id: this.item.id,
        type: this.item.type,
        payload: this.chart,
      };
    },
  },
  methods: {
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.$emit('update', this.payload);
    }, 300),
  },
  watch: {
    item: {
      handler() {
        if (this.item) {
          const chartData = JSON.parse(JSON.stringify(this.item.payload));
          this.chart = { ...this.chart, ...chartData };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
